import { useState, useRef } from "react";
import axios from "axios";

export const useTranscription = () => {
  const [isRecording, setIsRecording] = useState(false);
  const [transcription, setTranscription] = useState<string | null>(null);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const audioChunksRef = useRef<Blob[]>([]);

  const startRecording = () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          const mediaRecorder = new MediaRecorder(stream);
          mediaRecorderRef.current = mediaRecorder;

          mediaRecorder.ondataavailable = (event) => {
            audioChunksRef.current.push(event.data);
          };

          mediaRecorder.onstop = () => {
            const audioBlob = new Blob(audioChunksRef.current, {
              type: "audio/wav",
            });
            const formData = new FormData();
            formData.append("file", audioBlob, "audio.wav");
            formData.append("model", "whisper-large-v3");
            formData.append("language", "pt");
            formData.append("response_format", "verbose_json");

            axios
              .post(
                "https://api.groq.com/openai/v1/audio/transcriptions",
                formData,
                {
                  headers: {
                    Authorization: `Bearer ${process.env.NEXT_PUBLIC_GROQ_API_KEY}`,
                  },
                }
              )
              .then((response) => {
                if (response.data.text) {
                  const transcriptionResponse =
                    response.data.text === "E aí" ||
                    response.data.text === " E aí" ||
                    response.data.text === "Obrigado."
                      ? ""
                      : response.data.text;

                  setTranscription(transcriptionResponse);
                }
              })
              .catch((error) => {
                console.error("Erro ao transcrever o áudio:", error);
              });
          };

          mediaRecorder.start();
          setIsRecording(true);
        })
        .catch((error) => {
          console.error("Erro ao acessar o microfone:", error);
        });
    }
  };

  const stopRecording = () => {
    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state !== "inactive"
    ) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);

      const stream = mediaRecorderRef.current.stream;
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
    }
  };

  const cancelRecording = () => {
    if (mediaRecorderRef.current) {
      if (mediaRecorderRef.current.state !== "inactive") {
        mediaRecorderRef.current.stop();
      }

      const stream = mediaRecorderRef.current.stream;
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }

      audioChunksRef.current = [];
      setIsRecording(false);
      setTranscription(null);
    }
  };

  return {
    isRecording,
    transcription,
    startRecording,
    stopRecording,
    cancelRecording,
  };
};
